import FilledButton from "../../../component/FilledButton";
import { useLocation } from 'react-router-dom';

const AlertPop = ({ handleOpenModal, handleDelete }) => {
    const location = useLocation();
    const currentUrl = location.pathname;

    return (
        <div className="modal_body">
            <div className="attached_courses-alert delete-pop">
                <h2>Alert!</h2>
                <p className="text_center mt_3">You are trying to delete a   {currentUrl === '/program' ? 'program' : currentUrl === '/event' ? 'event': 'course' } that has 1 or more users attached to it.</p>
                <div className="desc">
                    Do you really want to delete this  {currentUrl === '/program' ? 'program' : currentUrl === '/event' ? 'event': 'course'} ?
                </div>
                <div className="action">
                    <FilledButton onClick={() => handleOpenModal()} value="cancel" />
                    <FilledButton onClick={() => handleDelete()} value="yes" className="btn btn_primary" />
                </div>
            </div>
        </div>
    )
};

export default AlertPop;